<template>
<!-- 项目统计 -->
    <div class="contain desPro">
        <div class="box">
            <div class="build-bar">
                <div>
                    <el-input placeholder="请输入项目名称" v-model="name" style="width:12vw;"></el-input>
                </div> 
                <div style="width:300px">
                    <el-button type="primary" class="add-user" @click="doFilter" >查询</el-button>
                </div>   
            </div>
            <div class="box-content">
                <el-table
                    :data="listData"
                    border
                    stripe
                    height="100%"
                    style="width: 100%;"
                >
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" width="100" fixed>
                        <template slot-scope="scope">
                            <span>{{ scope.row.index }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="项目名称" fixed>
                      <template slot-scope="scope">
                            <span style="width:100%;" class="nowrap" :title="scope.row.projectName">{{ scope.row.projectName }}</span>
                       </template>
                    </el-table-column>
                    <el-table-column label="类型" fixed width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.projectTypeName }}</span>
                        </template>
                    </el-table-column>

                    <el-table-column label="项目状态" width="100" fixed>
                        <template slot-scope="scope">
                          <span v-if="scope.row.projectStatus=='1'" style="color:#909399;">{{ scope.row.projectStatusName }}</span>
                          <span v-else-if="scope.row.projectStatus=='2'" style="color:#67C23A;">{{ scope.row.projectStatusName }}</span>
                          <span v-else-if="scope.row.projectStatus=='3'" style="color:#E6A23C;">{{ scope.row.projectStatusName }}</span>
                          <span v-else-if="scope.row.projectStatus=='4'" style="color:#303133;">{{ scope.row.projectStatusName }}</span>
                          <span v-else>{{ scope.row.projectStatusName }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="施工单位总人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.sgSum||0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="施工单位出勤人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.sgCq||0 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="施工单位">
                        <el-table-column label="总人数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.sgSum||0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="出勤数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.sgCq||0 }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="监理单位总人数" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jlSum||0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="监理单位出勤人数" width="200">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jlCq||0 }}</span>
                            </template>
                        </el-table-column> -->
                    <el-table-column label="监理单位">
                        <el-table-column label="总人数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jlSum||0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="出勤数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.jlCq||0 }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="检测单位总人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.JcSum||0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="检测单位出勤人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.JcCq||0 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="检测单位">
                        <el-table-column label="总人数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.JcSum||0 }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="出勤数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.JcCq||0 }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                    <!-- <el-table-column label="工人总人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.zzSum ||0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="工人出勤人数" width="200">
                        <template slot-scope="scope">
                            <span>{{ scope.row.zcSum||0 }}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="工人">
                        <el-table-column label="总人数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.zzSum ||0}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="出勤数" width="120">
                            <template slot-scope="scope">
                                <span>{{ scope.row.zcSum||0 }}</span>
                            </template>
                        </el-table-column>
                    </el-table-column>
                  <!-- <el-table-column label="在场总人数">
                        <template slot-scope="scope">
                            <span>{{ scope.row.zcSum}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="在职人数">
                        <template slot-scope="scope">
                            <span>{{ scope.row.zzSum}}</span>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label=" 扬尘检测">
                        <template slot-scope="scope">
                            <div class="envir">
                                <span v-for="(item,index) in scope.row.dustList" :key="index">
                                    <span v-if="item=='0'" class="box-grey"></span>
                                    <span v-if="item=='1'" class="box-green"></span>
                                    <span v-if="item=='2'" class="box-red"></span>
                                </span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="塔吊">
                        <template slot-scope="scope">
                            <div class="envir">
                                <span v-for="(item,index) in scope.row.towerList" :key="index">
                                    <span v-if="item=='0'" class="box-grey"></span>
                                    <span v-if="item=='1'" class="box-green"></span>
                                    <span v-if="item=='2'" class="box-red"></span>
                                </span>
                            </div>
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="handleEdit(scope.$index, scope.row)">移交记录</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                    style="padding-top:10px;"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
import base from '../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            listData:[],
            currentPage: 1,
            pageSize: 10,
            totalItems: 0,
            dataText:"数据加载中...",
            joinType:'',
            name:'',
            types:[],
            statusList:[],
        }
    },
    mounted() {
        this.groupId = util.session.get('groupId')
        if(util.session.get('roleId')=='3'){
            this.joinType = '3'
        }else if(util.session.get('roleId')=='5'){
            this.joinType = '2'
        }
        // this.getStatusType()
        this.getData()
    },
    methods:{
        doFilter(){
           
            this.getData()
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.currentChangePage()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.currentChangePage();
        },
        // 监控当前页码
        currentChangePage(list) {
            this.getData();
        },
        //点击过滤
        showProjectFun(index){
            this.search.unit = index
            this.getData()
        },
        //获取数据
        getData(){
            var that = this
            myHttp.getProjectByZDJPageList({
                groupId:this.groupId,
                joinType:this.joinType,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.PageInfo.list;
                    for(var i=0;i<list.length;i++){
                        list[i].index = list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        // var dustList = list[i].dust||[]
                        // list[i].dustList = []
                        // for(var j=0;j<dustList.length;j++){
                        //     if(new Date().getTime() - new Date(dustList[j].updateDate).getTime()>10*60000){
                        //         list[i].dustList.push(0)
                        //     }else{
                        //         list[i].dustList.push(1)
                        //     }
                        // }
                        // var tower = list[i].tower||[]
                        // list[i].towerList = []
                        // for(var k=0;k<tower.length;k++){
                        //     list[i].towerList.push(tower[k].status)
                        // }
                    }
                    // console.log(list)
                    that.listData = list;
                    that.totalItems = resp.data.data.PageInfo.total
                    if(that.listData.length==0){
                        that.dataText = "暂无数据"
                    }
                    if(that.types.length==0||that.statusList.length==0){
                        that.getStatusType()
                    }
                }
            })
        },
    
        //导出
        // exportOut(){
        //     var token = this.$store.state.token;
        //     window.open(myHttp.getExportInspectsByGroupId+'?groupId='+this.groupId+'&unit='+this.search.unit+'&date='+this.search.date+'&accessToken='+token)
        // },
        //查看
        // handleEdit(index,row){
        //     console.log(row)
        //     this.dialogTableVisible=true
        //     myHttp.selectContractHandRecordBycontractInitId({
        //         contractInitId:row.contractId
        //     }).then(function(resp){
        //         console.log(resp)
        //     })
        // },
        getStatusType(){
            var that = this
            myHttp.getDictByType({
                type:'project_type'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.dictList||[]
                    that.types = list
                    for(var i=0;i<that.listData.length;i++){
                        for(var j=0;j<list.length;j++){
                            if(that.listData[i].projectType==list[j].value){
                                that.listData[i].projectTypeName = list[j].label
                            }
                        }
                    }
                    // var listData = that.listData
                    that.listData = JSON.parse(JSON.stringify(that.listData))
                }
            })
            //project_status
            myHttp.getDictByType({
                type:'project_status'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.dictList||[]
                    that.statusList = list
                    for(var i=0;i<that.listData.length;i++){
                        for(var j=0;j<list.length;j++){
                            if(that.listData[i].projectStatus==list[j].value){
                                that.listData[i].projectStatusName = list[j].label
                            }
                        }
                    }
                    that.listData = JSON.parse(JSON.stringify(that.listData))
                }
            })
        },
    }
}
</script>
<style scoped>
    .contain{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .header-box{
        padding: 15px 20px;
        height: 70px;
        width: 100%;
        box-shadow: 1px 2px 3px 2px #ddd;
        background: #fff;
        box-sizing: border-box;
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* font-size: 18px; */
        /* color: #2058D9; */
    }
    .box{
        /* margin-top: 15px; */
        width: 100%;
        height: calc( 100% - 85px );
        background: #fff;
    }
    .box-content{
        width: 100%;
        height: calc( 100% - 55px );
        background: #fff;
    }
    .build-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
         justify-content: space-between;
        height: 80px;
        background: #fff;
        border-bottom: 3px solid #17b2fe;
        padding: 0 20px;
    }
    .el-form-item__label{
        color: inherit;
    }
    
    .box-green{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        animation: border_shrink .75s ease-out infinite;
        margin: 8px;
        background: rgb(54, 198, 53);
        display: inline-block;
    }
    .box-red{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        animation: border_red .75s ease-out infinite;
        margin: 8px;
        background: rgb(241, 43, 44);
        display: inline-block;
    }
    .box-grey{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        animation: border_grey .75s ease-out infinite;
        margin: 8px;
        background: rgb(178, 177, 177);
        display: inline-block;
    }
    @keyframes border_shrink {
        0% {
            box-shadow: 0 0px 0px 0px rgba(54, 198, 53, 0.14), 0 0px 0px 1px rgb(54, 198, 53,0.5);
        }
        100% {
            box-shadow: 0 0px 0px 3px rgba(54, 198, 53, 0.14), 0 0px 0px 4px rgba(54, 198, 53,0.5);
        }
    }
    @keyframes border_red {
        0% {
            box-shadow: 0 0px 0px 0px rgba(241, 43, 44, 0.14), 0 0px 0px 1px rgb(241, 43, 44,0.5);
        }
        100% {
            box-shadow: 0 0px 0px 3px rgba(241, 43, 44, 0.14), 0 0px 0px 4px rgba(241, 43, 44,0.5);
        }
    }
    @keyframes border_grey {
        0% {
            box-shadow: 0 0px 0px 0px rgba(178, 177, 177, 0.14), 0 0px 0px 1px rgb(178, 177, 177,0.5);
        }
        100% {
            box-shadow: 0 0px 0px 3px rgba(178, 177, 177, 0.14), 0 0px 0px 4px rgba(178, 177, 177,0.5);
        }
    }
</style>
<style>
    .build-bar span{
        margin-left: 0;
    }
    /* .el-table td, .el-table th{
        text-align: center;
    } */
    .caozuo{
        display: flex;
        justify-content: flex-end;
    }
    /* .el-dialog{
        width: 500px;
    } */
    .el-table--border th, .el-table__fixed-right-patch{
        border-bottom: 1px solid #303133;
    }
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
        border-right: 1px solid #303133;
    }
    .el-table td, .el-table th.is-leaf{
        border-bottom: 1px solid #303133;
    }
    .el-table--border, .el-table--group{
        border: 1px solid #303133;
    }
</style>